module.exports = __webpack_public_path__ + "./assets/f7fcb5bfc1455a46340fef5882e2d1a5.svg";